import Vue from 'vue';

export const PANEL_EMITTER_NAMESPACE = 'DCG_PANEL';
export const PANEL_CHANGE_EVENT = 'DCG_PANEL_CHANGE_EVENT';

// custom version of real panel mixin to send number of applied refinements instead.

export const createPanelProviderMixin = () => ({
  props: {
    emitter: {
      type: Object,
      required: false,
      default() {
        return new Vue({
          name: 'DcgPanelProvider',
        });
      },
    },
  },
  provide() {
    return {
      [PANEL_EMITTER_NAMESPACE]: this.emitter,
    };
  },
  data() {
    return {
      appliedRefinements: 0,
    };
  },
  created() {
    this.emitter.$on(PANEL_CHANGE_EVENT, value => {
      this.appliedRefinements = value;
    });
  },
  beforeDestroy() {
    this.emitter.$destroy();
  },
});

export const createPanelConsumerMixin = ({ mapStateToAppliedRefinements }) => ({
  inject: {
    emitter: {
      from: PANEL_EMITTER_NAMESPACE,
      default() {
        return {
          $emit: () => {},
        };
      },
    },
  },
  data() {
    return {
      state: null,
      hasAlreadyEmitted: false,
    };
  },
  watch: {
    state(nextState, previousState) {
      if (!previousState || !nextState) {
        return;
      }

      const previousValue = mapStateToAppliedRefinements(previousState);
      const nextValue = mapStateToAppliedRefinements(nextState);

      if (!this.hasAlreadyEmitted || previousValue !== nextValue) {
        this.emitter.$emit(PANEL_CHANGE_EVENT, nextValue);

        this.hasAlreadyEmitted = true;
      }
    },
  },
});
